__turbopack_context__.v({
  "accordion": "EducationalContent-module-scss-module__qvK_La__accordion",
  "card": "EducationalContent-module-scss-module__qvK_La__card",
  "cardHighlighted": "EducationalContent-module-scss-module__qvK_La__cardHighlighted",
  "cardsGrid": "EducationalContent-module-scss-module__qvK_La__cardsGrid",
  "component": "EducationalContent-module-scss-module__qvK_La__component",
  "content": "EducationalContent-module-scss-module__qvK_La__content",
  "header": "EducationalContent-module-scss-module__qvK_La__header",
  "icon": "EducationalContent-module-scss-module__qvK_La__icon",
  "list": "EducationalContent-module-scss-module__qvK_La__list",
  "listItem": "EducationalContent-module-scss-module__qvK_La__listItem",
  "proTipContent": "EducationalContent-module-scss-module__qvK_La__proTipContent",
  "proTipHeader": "EducationalContent-module-scss-module__qvK_La__proTipHeader",
  "proTipIcon": "EducationalContent-module-scss-module__qvK_La__proTipIcon",
  "proTipText": "EducationalContent-module-scss-module__qvK_La__proTipText",
  "proTipTitle": "EducationalContent-module-scss-module__qvK_La__proTipTitle",
  "title": "EducationalContent-module-scss-module__qvK_La__title",
});
